import React from "react";
import Onboarding from "../components/Onboarding";

const OnboardingScreen = (props) => {
  return <Onboarding {...props} />;
};
export default OnboardingScreen;
